import {
  LEAD_SUBMISSION_SUBMITTING,
  LEAD_SUBMISSION_SUCCESS,
  LEAD_SUBMISSION_ERROR,
  LEAD_SUBMISSION_RESET,
} from '../constants';

// reducers
const initialState = {
  submitted: false,
  submitting: false,
  response: null,
  request: null,
  error: null
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case LEAD_SUBMISSION_SUBMITTING:
      return {
        ...state,
        submitted: false,
        submitting: true,
        response: null,
        request: action.request,
        error: null
      };

    case LEAD_SUBMISSION_SUCCESS:
      return {
        ...state,
        submitted: true,
        submitting: false,
        response: action.response,
        error: null
      };

    case LEAD_SUBMISSION_ERROR:
      return {
        ...state,
        submitting: false,
        response: null,
        error: action.error
      };

    case LEAD_SUBMISSION_RESET:
      return {
        ...initialState
      };

    default:
      return state;
  }
}



/** WEBPACK FOOTER **
 ** ./src/redux/reducers/leads.js
 **/